import { Trans, useTranslation } from 'react-i18next'

import { Alert, Button, ButtonWithSpinner, Modal, Text } from '@reveni-io/reveni-ui'

import { modalModes } from '../hooks/useBulkOnHold/constants'
import { acceptTextByMode, titleByMode } from './constants'
import * as Styles from './styles'

const BulkOnHoldTransactionsModal = ({
  show,
  onClose,
  mode,
  approving,
  declining,
  onApprove,
  onDecline,
  selectedOrders,
}) => {
  const { t } = useTranslation()
  const selectedOrdersCount = selectedOrders?.length || 0

  return (
    <Modal show={show} onClose={onClose} title={t(titleByMode[mode])} size="l">
      <Styles.Container>
        <Text type="bodyMRegular">
          {mode === modalModes.approve && (
            <Trans i18nKey="bulkOnHoldModalTextOnApprove" values={{ selectedOrdersCount }}>
              Al aprobar estas {{ selectedOrdersCount }} solicitudes, su estado se actualizará a{' '}
              <strong>En proceso</strong> o <strong>Pendiente</strong> y se enviarán al cliente las notificaciones{' '}
              <strong>Confirmación de solicitud</strong> o <strong>Pago pendiente</strong> correspondientes.
            </Trans>
          )}

          {mode === modalModes.decline && (
            <Trans i18nKey="bulkOnHoldModalTextOnDecline" values={{ selectedOrdersCount }}>
              Al rechazar estas {{ selectedOrdersCount }} solicitudes, su estado se actualizará a{' '}
              <strong>Cancelada</strong> y se enviará al cliente la notificación de <strong>Solicitud cancelada</strong>{' '}
              correspondiente.
            </Trans>
          )}
        </Text>
        <Alert type="warning">{t('Esta acción no se podrá deshacer más adelante. ¿Quieres continuar?')}</Alert>
        <Styles.ActionsContainer>
          <Button fullWidth onClick={onClose} variant="outlined">
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            defaultLabel={t(acceptTextByMode[mode])}
            loadingLabel={t(acceptTextByMode[mode])}
            loading={approving || declining}
            disabled={approving || declining}
            onClick={mode === modalModes.approve ? onApprove : onDecline}
          />
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default BulkOnHoldTransactionsModal
